export default __webpack_public_path__ + "static/media/ckay.84090f30.jpg";